/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/**
 * A value range
 */

/**
 * Returns a string-representation of the given value-range.
 */
export function valueRangeToString(valueRange) {
  var _valueRange$start, _valueRange$end;

  return `[${(_valueRange$start = valueRange === null || valueRange === void 0 ? void 0 : valueRange.start) !== null && _valueRange$start !== void 0 ? _valueRange$start : 'undefined'}, ${(_valueRange$end = valueRange === null || valueRange === void 0 ? void 0 : valueRange.end) !== null && _valueRange$end !== void 0 ? _valueRange$end : 'undefined'}]${(valueRange === null || valueRange === void 0 ? void 0 : valueRange.scale) === ValueRangeScale.log10 ? '_log' : ''}`;
}
/**
 * The type of a value range
 */

export let ValueRangeScale;

(function (ValueRangeScale) {
  ValueRangeScale["linear"] = "linear";
  ValueRangeScale["log10"] = "log10";
})(ValueRangeScale || (ValueRangeScale = {}));
